
$(document).ready(function(){
    $(document).on('click', '.btn-set-lang', function(e){
        e.stopImmediatePropagation();
        e.preventDefault();

        var lang = $(this).data('lang');
        set_lang(lang);
    });
});

function set_lang(lang) {
    $.post('/members/user/set_lang', {
        lang: lang,
    }).done(function(json) {
        if (json.status) {
            if (json.hasOwnProperty('return_url')) {
                window.location.href = get_lang_url(json.return_url, 'set_lang', lang);
            } else {
                window.location.reload(true);
            }
        }
    });
}

function get_lang_url(source_url, key, lang) {
    var rtn = source_url.split("?")[0],
        lang_qs = 'set_lang=' + lang,
        param,
        params_arr = [],
        qs = (source_url.indexOf("?") !== -1) ? source_url.split("?")[1] : "";
    if (qs !== "") {
        params_arr = qs.split("&");
        
        // remove duplicate set_lang params if any
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        // add set_lang param
        params_arr.push(lang_qs);
        rtn = rtn + "?" + params_arr.join("&");
    } else {
        rtn = rtn + "?" + lang_qs;
    }
    return rtn;
}